module.exports = __webpack_public_path__ + "img/haijunlan2.6f906c05.png";